import he from 'he';

export const escapeHtml = {
    /**
     * Helper for HTML encoding/decoding using the 'he' library
     * @author LiveLaps Development Team
     * @version 1.0.0
     * @copyright LiveLaps Inc. 2024
     * @developer Lorena Salas
     */

    /**
     * Decodes HTML entities to their corresponding characters
     * @param {string} html - The HTML string to decode
     * @returns {string} The decoded string, or original value if not a string
     */
    decode(html) {
        if(typeof html == 'string') {
            return he.decode(html);
        }
        return html;
    },

    /**
     * Encodes characters to their corresponding HTML entities
     * @param {string} html - The string to encode
     * @returns {string} The encoded string, or original value if not a string
     */
    encode(html) {
        if(typeof html == 'string') {
            return he.encode(html);
        }
        return html;
    }
};
